import { FraudulentTransactionDetails } from 'commons/models/confiscation.model';

export interface IUpdateProps {
	isApproved: boolean;
	rejectionReason?: string;
	confiscationId: string;
}

export interface IUseCreateProps {
	uid: number;
	transactionId: number;
	refundType: string;
	amount?: string;
	freshdeskTicketId: number;
	reportedBy?: string;
	reportedOn: number;
	confiscationType: string;
}

export interface IBulkConfiscationUpload {
	gameName: string;
	csvName: string;
	description: string;
	csv: File;
	[key: string]: string | File;
}

export interface ICsvDataWrapper {
	csvData: IBulkConfiscationUpload;
}

export interface ICreateProps extends Omit<IUseCreateProps, 'amount'> {
	amount?: number;
}

export interface IFraudulentTransactionDetails extends Omit<FraudulentTransactionDetails, '_id'> {
	_id?: string;
}

export interface IReject {
	rowData: IFraudulentTransactionDetails;
	fetchConfiscationAndRefundData: () => any;
}

export interface IUseRejectProps {
	rejectionReason: string;
}

export type FraudFilters = {
	startTime: number;
	endTime: number;
};

export interface pageDetailsType {
	pageNo: number;
	pageSize: number;
}

export enum ConfiscationAndRefundRequestRefundType {
	REFUND_TO_SOURCE = 'REFUND_TO_SOURCE',
	REFUND_TO_BANK = 'REFUND_TO_BANK',
	CRM_EXCEPTIONAL = 'CRM_EXCEPTIONAL',
	FRAUD_DISPUTE = 'FRAUD_DISPUTE',
	OTHERS = 'OTHERS'
}

export enum ConfiscationAndRefundRequestConfiscationType {
	ACCOUNT_DEACTIVATION = 'ACCOUNT_DEACTIVATION',
	IOS_DELETION = 'IOS_DELETION',
	RESTRICTED_STATE_CONFISCATION = 'RESTRICTED_STATE_CONFISCATION',
	MISTAKE_DEPOSIT_CONFISCATION = 'MISTAKE_DEPOSIT_CONFISCATION',
	LEGAL_THREAT_CONFISCATION = 'LEGAL_THREAT_CONFISCATION',
	LIFE_THREAT_CONFISCATION = 'LIFE_THREAT_CONFISCATION',
	MINOR_ACCOUNT_CONFISCATION = 'MINOR_ACCOUNT_CONFISCATION',
	FRAUD_CONFISCATION = 'FRAUD_CONFISCATION' // Ensure this enum value is valid and exists
}

// Refund options
export const CONFISCATION_AND_REFUND_REQUESTS_OPTIONS = [
	{ id: ConfiscationAndRefundRequestRefundType.REFUND_TO_SOURCE, label: ConfiscationAndRefundRequestRefundType.REFUND_TO_SOURCE },
	{ id: ConfiscationAndRefundRequestRefundType.REFUND_TO_BANK, label: ConfiscationAndRefundRequestRefundType.REFUND_TO_BANK },
	{ id: ConfiscationAndRefundRequestRefundType.CRM_EXCEPTIONAL, label: ConfiscationAndRefundRequestRefundType.CRM_EXCEPTIONAL },
	{
		id: ConfiscationAndRefundRequestRefundType.FRAUD_DISPUTE,
		label: ConfiscationAndRefundRequestRefundType.FRAUD_DISPUTE
	},
	{ id: ConfiscationAndRefundRequestRefundType.OTHERS, label: ConfiscationAndRefundRequestRefundType.OTHERS }
];

// Confiscation types
export const CONFISCATION_TYPE_OPTIONS = [
	{
		id: ConfiscationAndRefundRequestConfiscationType.ACCOUNT_DEACTIVATION,
		label: ConfiscationAndRefundRequestConfiscationType.ACCOUNT_DEACTIVATION
	},
	{
		id: ConfiscationAndRefundRequestConfiscationType.IOS_DELETION,
		label: ConfiscationAndRefundRequestConfiscationType.IOS_DELETION
	},
	{
		id: ConfiscationAndRefundRequestConfiscationType.RESTRICTED_STATE_CONFISCATION,
		label: ConfiscationAndRefundRequestConfiscationType.RESTRICTED_STATE_CONFISCATION
	},
	{
		id: ConfiscationAndRefundRequestConfiscationType.MISTAKE_DEPOSIT_CONFISCATION,
		label: ConfiscationAndRefundRequestConfiscationType.MISTAKE_DEPOSIT_CONFISCATION
	},
	{
		id: ConfiscationAndRefundRequestConfiscationType.LEGAL_THREAT_CONFISCATION,
		label: ConfiscationAndRefundRequestConfiscationType.LEGAL_THREAT_CONFISCATION
	},
	{
		id: ConfiscationAndRefundRequestConfiscationType.LIFE_THREAT_CONFISCATION,
		label: ConfiscationAndRefundRequestConfiscationType.LIFE_THREAT_CONFISCATION
	},
	{
		id: ConfiscationAndRefundRequestConfiscationType.MINOR_ACCOUNT_CONFISCATION,
		label: ConfiscationAndRefundRequestConfiscationType.MINOR_ACCOUNT_CONFISCATION
	},
	{
		id: ConfiscationAndRefundRequestConfiscationType.FRAUD_CONFISCATION,
		label: ConfiscationAndRefundRequestConfiscationType.FRAUD_CONFISCATION
	} // Re-added
];
